import { typographyResponsive } from "../../styles/utils";
import { stripUnit } from "../../styles/utils/utils";
export const MuiListItemTextTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            dense: {},
            inset: {},
            multiline: {},
            root: {
                display: "flex",
                flexDirection: "column",
                margin: 0,
                gap: dt.space.inline.xSmall4,
                overflow: "hidden",
                textOverflow: "ellipsis",
                ".MuiTypography-root": {
                    display: "block",
                },
                ".MuiTypography-overline": {
                    color: dt.color.onSurface.variant,
                    textTransform: "uppercase",
                },
                "& + .MuiListItemIcon-root": {
                    marginLeft: `${stripUnit(dt.inline.large) - stripUnit(dt.inline.medium)}px`,
                },
            },
            primary: Object.assign(Object.assign({}, typographyResponsive(dt, "body1.regular")), { overflow: "hidden", textOverflow: "ellipsis", color: dt.color.onSurface.key, "&:empty": {
                    display: "none",
                } }),
            secondary: Object.assign(Object.assign({}, typographyResponsive(dt, "body2.regular")), { "&[class]": {
                    display: "flex",
                }, flexDirection: "column", gap: dt.space.inline.xSmall4, overflow: "hidden", textOverflow: "ellipsis", color: dt.color.onSurface.variant, "&:empty": {
                    display: "none",
                } }),
        },
    };
};
